import CardinalCommerceProvider from './CardinalCommerceProvider';
import ThreeDSecureIOProvider from './3dsecureio/Provider';
import { ClientContext } from '../core/ClientContextFactory';
import { ApiEvent } from '../analytics/constants/enums';

export default class ThreeDSecure {
  private context: ClientContext;

  private provider: any | null;

  constructor({ context }: { context: ClientContext }) {
    this.context = context;

    this.provider = null;
  }

  async getContext(): Promise<ClientContext> {
    return this.context;
  }

  async getProvider() {
    if (!this.provider) {
      const context = await this.getContext();
      const provider = context.session.threeDSecureProvider;

      switch (provider) {
        case '3DSECUREIO':
          this.provider = new ThreeDSecureIOProvider(context);
          break;
        case 'CARDINAL':
        default:
          this.provider = new CardinalCommerceProvider(context);
          break;
      }
    }

    return this.provider;
  }

  async setup(options: Record<string, unknown>) {
    const provider = await this.getProvider();
    provider.setup(options);
  }

  async verify(options: Record<string, unknown>) {
    const provider = await this.getProvider();
    const context = await this.getContext();

    // analytics, track 3ds event triggered.
    context.analytics.call({ event: ApiEvent.triggered3ds });

    return provider.verify(options);
  }
}
